import { useState } from "react";
import { IonText } from "@ionic/react";
import { Icon, IconName } from "swing-components";

import { translate } from "~utils";

/***** Body Components *****/
type CopyableContactRowProps = {
  ariaLabel: string;
  icon: IconName;
  displayValue: string;
  copyValue: string;
  wrap?: boolean;
};

export function CopyableContactRow({
  ariaLabel,
  icon,
  displayValue,
  copyValue,
  wrap,
}: CopyableContactRowProps) {
  const [justCopied, setJustCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(copyValue);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = copyValue;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setJustCopied(true);
      setTimeout(() => setJustCopied(false), 2000);
    } catch {
      // Clipboard access denied; leave UI unchanged.
    }
  };

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={handleCopy}
      css={{
        all: "unset",
        cursor: "pointer",
        display: "flex",
        flexWrap: "wrap",
        gap: "var(--spacing-base)",
        alignItems: "center",
        ":focus-visible": { outline: "2px solid var(--swing-blue500)", outlineOffset: 2 },
      }}
    >
      <Icon name={icon} />
      <IonText
        className="swing-text"
        css={{
          color: "var(--swing-blue500)",
          textDecoration: "underline",
          overflowWrap: wrap ? "anywhere" : undefined,
        }}
      >
        {displayValue}
      </IonText>
      {justCopied && (
        <IonText
          className="swing-text"
          css={{
            color: "var(--swing-green500)",
            fontWeight: "var(--swing-font-semibold)",
            backgroundColor: "var(--swing-green200)",
            padding: "0 var(--spacing-sm)",
            borderRadius: "var(--spacing-base)",
            lineHeight: 1.5,
          }}
        >
          {translate("SUB_INFO_CARD_COPIED")}
        </IonText>
      )}
    </button>
  );
}
